import { useState } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DefaultForm } from "../../components";
import { StatType } from "../../entities/enums";
import { StatInfoComputeModel } from "../../entities/statInfo";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";
import { Alert } from "antd";

interface StatInfoComputerProps {
  computeCallback: (data: StatInfoComputeModel) => Promise<boolean>;
}

export const StatInfoComputer = ({ computeCallback }: StatInfoComputerProps) => {
  const [isComputing, setIsComputing] = useState(false);

  let model: StatInfoComputeModel = {
      companyId: undefined,
      type: StatType.None,
      computeAll: false
  };

  const onFinish = async (values: any) => {
    let computeModel: StatInfoComputeModel = {
      ...values,
      companyId: values.companyId ?? 0
    };

    setIsComputing(true);

    await computeCallback(computeModel);

    setIsComputing(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect name="companyId" label="شرکت" placeholder="انتخاب شرکت" wrapperCol={{xs: 24, lg: 12}}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
      />

      <DefaultForm.EnumSelect name="type" label="نوع آمار" type={StatType} wrapperCol={{xs: 24, lg: 12}} />
      <DefaultForm.Checkbox name="computeAll" label="محاسبه همه" />

      <DefaultForm.SubmitButton loading={isComputing} icon={<FontAwesomeIcon className="anticon" icon={faCheck} />}>
          محاسبه و ذخیره
      </DefaultForm.SubmitButton>
      <Alert type="warning" className="lg:w-1/2" closable message="محاسبه اطلاعات آماری بر اساس داده های آماری موجود"/>
    </DefaultForm>
  );
};
